import Loadable from 'react-loadable';

export const LoginContainer = Loadable({
  loader: () => import('./LoginForm'),
  loading: () => null,
});



// WEBPACK FOOTER //
// ./src/containers/LoginForm/index.ts